import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';


const unitOfMeasuresAdapter = getAdapter();

const unitOfMeasureSlice = createSlice({
  name: 'unitOfMeasures',
  initialState: unitOfMeasuresAdapter.getInitialState(),
  reducers: {
    setUnitOfMeasures: (state, { payload: { unitOfMeasures } }) => {
      unitOfMeasuresAdapter.setAll(state, unitOfMeasures);
    }
  }
});

const selectors = unitOfMeasuresAdapter.getSelectors(({ unitOfMeasures }) => unitOfMeasures);

export const getUnitOfMeasures = state => selectors.selectAll(state);

export const { setUnitOfMeasures } = unitOfMeasureSlice.actions;

export default unitOfMeasureSlice.reducer;